export default __webpack_public_path__ + "static/media/loading.bcea7fa0.gif";